export default "__VITE_ASSET__CfkA3LVZ__"